export const HOME_LOAD_SUCCESS = 'home/LOAD_SUCCESS';
export const HOME_EDIT_SUCCESS = 'home/EDIT_SUCCESS';
export const SET_BUSY = 'home/SET_BUSY';
export const UNSET_BUSY = 'home/UNSET_BUSY';
